import { checkIsTypeScriptProject } from "./checkIsTypeScriptProject.js";
const getJSFileExtension = async ({ helpers, options }) => {
  const isTypeScriptProject = await checkIsTypeScriptProject({
    helpers,
    options
  });
  return isTypeScriptProject ? "ts" : "js";
};
export {
  getJSFileExtension
};
//# sourceMappingURL=getJSFileExtension.js.map
